export default function ChatgptFindTitle() {
  return <h2>Chatgpt Find Title</h2>;
}
